/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {
  signal: {
    libList: `${base.url}/merchandiser/signal/lib/list`,
    libAsSignal: `${base.url}/merchandiser/signal/lib/asSignal`,
    libDetail: `${base.url}/merchandiser/signal/lib/detail`,
    libUpdate: `${base.url}/merchandiser/signal/lib/update`,

    configGet: `${base.url}/merchandiser/signal/config/get`,
    configEdit: `${base.url}/merchandiser/signal/config/edit`,

    sourceList: `${base.url}/merchandiser/signal/source/list`,
    sourceDel: `${base.url}/merchandiser/signal/source/del`,
    sourceStatus: `${base.url}/merchandiser/signal/source/status`,
    sourceEdit: `${base.url}/merchandiser/signal/source/edit`,
    hall: `${base.url}/merchandiser/signal/source/hall`,

    sourceApplyList: `${base.url}/merchandiser/signal/sourceApply/list`,
    sourceApplyStatus: `${base.url}/merchandiser/signal/sourceApply/status`,
    sourceApplyAdd: `${base.url}/merchandiser/signal/sourceApply/add`,

    sourceLogList: `${base.url}/merchandiser/signal/log/list`,

    productList: `${base.url}/merchandiser/signal/product/list`,
    productEdit: `${base.url}/merchandiser/signal/product/edit`,

    customerList: `${base.url}/merchandiser/signal/customer/list`,
    subscribeList: `${base.url}/merchandiser/signal/subscribe/list`,
    subscribeFollowers: `${base.url}/merchandiser/signal/followers`,
    subscribe: `${base.url}/merchandiser/signal/subscribe`,
    unsubscribe: `${base.url}/merchandiser/signal/unsubscribe`,
    subscribeSetting: `${base.url}/merchandiser/signal/subscribe_setting`,

    closeSummary: `${base.url}/merchandiser/signal/closeSummary`,

    openList: `${base.url}/merchandiser/signal/subscribe/open/list`,
    closeList: `${base.url}/merchandiser/signal/subscribe/close/list`,


  },
  company: {
    companyList: `${base.url}/merchandiser/company/list`,
    companyListAll: `${base.url}/merchandiser/company/listAll`,
    companyEdit: `${base.url}/merchandiser/company/edit`,
    companyDel: `${base.url}/merchandiser/company/del`,

    companyProduct: `${base.url}/merchandiser/company/product`,
    companyProductSyn: `${base.url}/merchandiser/company/product/syn`,

    mappingList: `${base.url}/merchandiser/company/symbol/mapping/list`,
    mappingEdit: `${base.url}/merchandiser/company/symbol/mapping/edit`,
    mappingDel: `${base.url}/merchandiser/company/symbol/mapping/del`,
  },


}


